import { useState } from 'react';
import LandingNav from './components/LandingNav';
import HeroSection from './components/HeroSection';
import FeaturesSection from './components/FeaturesSection';
import HowItWorksSection from './components/HowItWorksSection';
import PricingSection from './components/PricingSection';
import TestimonialsSection from './components/TestimonialsSection';
import FooterSection from './components/FooterSection';
import MarketSection from './components/MarketSection';

export default function Home() {
  const [policyModal, setPolicyModal] = useState<'terms' | 'privacy' | null>(null);

  return (
    <div className="min-h-screen">
      <LandingNav onOpenPolicy={setPolicyModal} />
      <HeroSection />
      <FeaturesSection />
      <HowItWorksSection />
      <PricingSection />
      <MarketSection />
      <TestimonialsSection />
      <FooterSection onOpenPolicy={setPolicyModal} />

      {/* Policy Modal */}
      {policyModal && (
        <div className="fixed inset-0 z-[200] flex items-center justify-center bg-black/50 backdrop-blur-sm p-4" onClick={() => setPolicyModal(null)}>
          <div className="bg-white rounded-2xl w-full max-w-[680px] max-h-[80vh] flex flex-col overflow-hidden" onClick={e => e.stopPropagation()}>
            <div className="flex items-center justify-between px-6 py-4 border-b border-gray-100">
              <h3 className="font-bold text-[#7C2D12] text-base flex items-center gap-2">
                <i className={`${policyModal === 'terms' ? 'ri-file-text-fill' : 'ri-shield-check-fill'} text-orange-500`}></i>
                {policyModal === 'terms' ? '用户协议' : '隐私政策'}
              </h3>
              <button onClick={() => setPolicyModal(null)} className="w-8 h-8 flex items-center justify-center text-gray-400 hover:text-gray-600 cursor-pointer rounded-lg hover:bg-gray-100">
                <i className="ri-close-line text-xl"></i>
              </button>
            </div>
            <div className="flex-1 overflow-y-auto px-6 py-5 text-sm text-gray-600 leading-relaxed space-y-4">
              {policyModal === 'terms' ? (
                <>
                  <p className="text-xs text-gray-400">最后更新：2026年1月1日</p>
                  <h4 className="font-bold text-gray-800">一、服务说明</h4>
                  <p>习惯星球（以下简称"本平台"）是一款面向家庭的儿童习惯养成管理工具。通过积分奖惩机制，帮助家长科学培养孩子的良好习惯。</p>
                  <h4 className="font-bold text-gray-800">二、用户注册与账号</h4>
                  <p>用户需通过手机号或第三方账号（微信、抖音）注册。每个手机号仅可注册一个账号。用户应妥善保管账号信息，因账号泄露造成的损失由用户自行承担。</p>
                  <h4 className="font-bold text-gray-800">三、服务内容</h4>
                  <p>本平台提供家庭积分管理、习惯分析、激励市场、家庭银行等功能。免费版用户享有基础功能，VIP会员可解锁全部高级功能。</p>
                  <h4 className="font-bold text-gray-800">四、用户行为规范</h4>
                  <p>用户不得利用本平台从事违法活动，不得传播不良信息，不得侵犯他人权益。违反规定者，本平台有权暂停或终止服务。</p>
                  <h4 className="font-bold text-gray-800">五、知识产权</h4>
                  <p>本平台所有内容（包括但不限于文字、图片、代码）均受知识产权法律保护，未经授权不得复制或传播。</p>
                  <h4 className="font-bold text-gray-800">六、免责声明</h4>
                  <p>本平台不对因网络故障、不可抗力等原因造成的服务中断承担责任。积分数据仅供参考，不构成任何法律承诺。</p>
                  <h4 className="font-bold text-gray-800">七、协议变更</h4>
                  <p>本平台有权随时修改本协议，修改后将在平台内公告。继续使用本平台即视为接受修改后的协议。</p>
                  <h4 className="font-bold text-gray-800">八、联系我们</h4>
                  <p>如有疑问，请联系客服邮箱：support@habitplanet.com</p>
                </>
              ) : (
                <>
                  <p className="text-xs text-gray-400">最后更新：2026年1月1日</p>
                  <h4 className="font-bold text-gray-800">一、信息收集</h4>
                  <p>我们收集您在注册和使用过程中提供的信息，包括：手机号码、家庭成员信息（姓名、年龄等）、使用行为数据（积分记录、习惯数据等）。</p>
                  <h4 className="font-bold text-gray-800">二、信息使用</h4>
                  <p>收集的信息用于：提供和改善服务、个性化推荐、数据分析、安全防护。我们不会将您的个人信息出售给第三方。</p>
                  <h4 className="font-bold text-gray-800">三、儿童隐私保护</h4>
                  <p>本平台高度重视儿童隐私保护。儿童相关数据仅用于家庭内部管理，不会用于商业目的。家长对儿童数据拥有完全控制权。</p>
                  <h4 className="font-bold text-gray-800">四、数据安全</h4>
                  <p>我们采用行业标准的加密技术保护您的数据安全。所有数据传输均使用HTTPS加密，服务器数据定期备份。</p>
                  <h4 className="font-bold text-gray-800">五、Cookie使用</h4>
                  <p>我们使用Cookie来保持登录状态和改善用户体验。您可以在浏览器设置中管理Cookie偏好。</p>
                  <h4 className="font-bold text-gray-800">六、您的权利</h4>
                  <p>您有权访问、更正、删除您的个人信息。如需行使上述权利，请联系我们的客服团队。</p>
                  <h4 className="font-bold text-gray-800">七、第三方服务</h4>
                  <p>本平台可能集成第三方服务（如微信登录），这些服务有其独立的隐私政策，请参阅相应服务商的隐私说明。</p>
                  <h4 className="font-bold text-gray-800">八、联系我们</h4>
                  <p>隐私相关问题请联系：privacy@habitplanet.com</p>
                </>
              )}
            </div>
            <div className="px-6 py-4 border-t border-gray-100">
              <button onClick={() => setPolicyModal(null)} className="w-full py-3 rounded-xl text-white font-bold cursor-pointer whitespace-nowrap hover:opacity-90 transition-opacity"
                style={{ background: 'linear-gradient(135deg,#EA580C,#7C2D12)' }}>
                我已阅读并了解
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
